import PropTypes from 'prop-types';
import React from 'react';

export default function AdDataComment({ ad_data, prefix, suffix }, { location }) {
  prefix = prefix || '<!--';
  suffix = suffix || '-->';

  const strippedAdData = JSON.stringify({
    ...ad_data,
    ad_test: location.query.test
  })
    .replace(/,/g, ',\n')
    .replace(/--+/, '')
    .replace(/[\n\r\t]+/g, '');

  const comment = `${prefix} ad_vars targeting ${strippedAdData} ${suffix}`;

  return (
    <span id="ad-data" dangerouslySetInnerHTML={{ __html: comment }} />
  );
}

AdDataComment.propTypes = {
  ad_data: PropTypes.object.isRequired,
  prefix: PropTypes.string,
  suffix: PropTypes.string
};

AdDataComment.contextTypes = {
  location: PropTypes.object
};
